<template>
  <div class="container">
    <div class="pg-pd12">
      <div class="com-box">
          <div>只看{{this.areaType==1?'一':'二'}}类地区</div>
           <van-switch v-model="checked" active-color="#07c160"  inactive-color="#E4E4E5" @click="change" />
      </div>

        <div class="content" v-if="ranking.length>0">
          <div class="content-pd16">
            <rankCharts class="mt13" :rankList="ranking" :checked="checked" :areaType="areaType" />
          </div>
        </div>
       <!-- 没有数据提示 -->
        <div v-else class="noData-bg">
              <nodata :noData="noData"></nodata>
        </div>
       </div>

  </div>
</template>
<script>
    import Vue from 'vue';
    import rankCharts from './components/RankCharts';
    import api from '../../service/modules/appraise';
    import nodata from './components/nodata';// 没有数据
    import {
        Picker, Switch
    } from 'vant';
    // import { stringify } from 'querystring';

    Vue.use(Picker);
    Vue.use(Switch);
    export default {
        components: {
            rankCharts, nodata
        },

        data () {
            return {
                noData: {
                    title: '暂无数据'
                },
                city: false,
                checked: true,
                ranking: [
                  {}
                ],
                areaType: 1,
                year: '',
                quarter: '',
                content: {},
                isError: false
            }
        },

        computed: {},

        watch: {},

        methods: {
            change () {
                this.checked = !this.checked
                if (this.checked == true) {
                    this.getCityList()
                } else {
                    this.getAllCity()
                }
            },
            getCityList () { // 季度、省市
                api.getAssessScoreByAreaType({ areaType: this.areaType, year: this.year, quarter: this.quarter }).then(res => {
                    if (res.ret === 0) {
                        this.ranking = res.data.list
                        this.sortList(this.ranking)
                    }
                }).catch(function (error) {
                    if (error.response) {
                        this.isError = true
                    } ;
                })
            },
            getAllCity () {
                api.getAssessScoreByProvince({ year: this.year, quarter: this.quarter }).then(res => {
                    this.ranking = res.data.list
                    this.sortList(this.ranking)
                })
            },
            sortList (list) { // 排序
                list.sort((x, y) => {
                    return x.ranking - y.ranking
                })
            }
        },

        mounted () {
        },

        created () {
            this.content = JSON.parse(sessionStorage.getItem('content'))
            this.areaType = this.content.areaType
            this.year = this.content.year
            this.quarter = this.content.quarter
            console.log(this.content, 'dfdfdf')
            this.getCityList()
        }

    }
</script>
<style scoped lang="less">
  .container {
    min-height: 100vh;
    background: rgba(251, 251, 251, 1);
  .pg-pd12 {
      padding-left: 12px;
      padding-right: 12px;
      padding-top: 16px;
      padding-bottom: 30px;
      display: flex;
      flex-direction: column;
      min-height: 100vh;
    box-sizing: content-box;
    }
    .noData-bg{
        flex:1;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .com-box{
            display: flex;
            align-items: center;
              .van-switch{
              border: solid 1Px #E4E4E5;
              width: 40px;
              height: 24px;
            }
            .van-switch.van-switch--on{
              border: solid 1Px #36B374;
            }
            .van-switch__node{
              box-shadow:none;
              width: 22px;
              height: 22px;
              top: 1px;
              left: 1px;
            }
            .van-switch--on .van-switch__node{
              left: 0;
            }
          }

      .content{
        background:rgba(255,255,255,1);
        box-shadow:0px 0px 10px 0px rgba(0,0,0,0.04);
        border-radius:3px;
        margin-top: 12px;
        &-pd16{
          padding:4px 16px;
        }
      }
  }
</style>
